export default __webpack_public_path__ + "static/media/arrow-down.7087ec76.svg";